/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import className from 'classnames';
import { Link } from '@fluentui/react';
import { ErrorType, Errors } from '../../common/error-type';
import { StringsMapping } from '../../common/strings';
import { CalloutWithLock } from './popup';

function PopupContent({
  bodyText, goalNames = [], newI18n, updateFilterAndRoute,
}) {
  const goalList = useMemo(
    () => {
      if (goalNames.length === 0) {
        return null;
      }
      return (
        <ul
          className="popup-goal-list"
          style={{ marginTop: 10, paddingInlineStart: 15, marginBottom: 10 }}
        >{goalNames.map(goalName =>
        (
          <li className="popup-goal-name" key={goalName}>
            <div
              className="popup-goal-name-text"
              style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
            >{goalName}
            </div>
          </li>
        ))
          }
        </ul>
      );
    }
    , [goalNames]
  );

  const seeAllText = useMemo(
    () => newI18n.getString(StringsMapping.See_All)
    , [newI18n]
  );
  return (
    <React.Fragment>
      <div className="popup-content">
        {bodyText}
        {goalList}
        <Link
          className="see-all-link"
          onClick={updateFilterAndRoute}
        >
          {seeAllText}
        </Link>
      </div>
    </React.Fragment>
  );
}

function PopupContentNoRevenue({
  newI18n,
}) {
  const noRevenueText = useMemo(
    () => newI18n.getString(StringsMapping.NoReveueText)
    , [newI18n]
  );

  return (
    <React.Fragment>
      <div className="popup-content">
        {noRevenueText}
        <Link
          to="https://help.ads.microsoft.com/#apex/ads/en/56716/2"
          className="no-revenue-link"
        >
          {newI18n.getString(StringsMapping.Learn_More)}
        </Link>
      </div>
    </React.Fragment>
  );
}


function Line(props) {
  const {
    number, type, newI18n, goalNames,
    TrackingTypeFilterStore,
    router,
    instrumentationLog,
  } = props;

  const [hoverCardStatus, setHoverCardStatus] = useState(false);

  const navigateToConversionGoals = useCallback(() => {
    if (router) {
      instrumentationLog.SeeAllClicked(type);
      router.navigateToRoute('conversiongoals');
    }
  }, [instrumentationLog, router, type]);

  const updateFilterAndRoute = useCallback(() => {
    if (TrackingTypeFilterStore) {
      TrackingTypeFilterStore(type);
    }
    navigateToConversionGoals();
  }, [TrackingTypeFilterStore, navigateToConversionGoals, type]);

  const formattedNumber = useMemo(
    () => `${newI18n.getString(StringsMapping.Number_Of_Goals, { number })}`,
    [newI18n, number]
  );
  const titleText = useMemo(
    () => newI18n.getString(Errors[type].Title),
    [newI18n, type]
  );
  const statusText = useMemo(
    () => newI18n.getString(Errors[type].Status),
    [newI18n, type]
  );
  const MessageText = useMemo(
    () => newI18n.getString(Errors[type].Message),
    [newI18n, type]
  );
  const errorClassName = useMemo(() => Errors[type].ClassName, [type]);

  const ref = useRef(null);

  const renderLine = useCallback(() => {
    if (type === ErrorType.RecordingConversions) {
      return (
        <div
          className={className('error-status', errorClassName)}
          onMouseLeave={() => setHoverCardStatus(false)}
        >
          {`${formattedNumber}${statusText}`}
          {hoverCardStatus && <CalloutWithLock
            title={titleText}
            target={ref.current}
            content={<PopupContentNoRevenue
              newI18n={newI18n}
            />}
            close={() => { setHoverCardStatus(false); }}
            popoverId={type}
          />}
        </div>
      );
    }
    return (
      <div
        className={className('error-status', errorClassName)}
        onMouseLeave={() => setHoverCardStatus(false)}
      >
        <div
          className="error-status-number"
          onMouseEnter={() => setHoverCardStatus(true)}
          ref={ref}
        >{formattedNumber}
        </div>
        {statusText}
        {hoverCardStatus && <CalloutWithLock
          title={titleText}
          target={ref.current}
          content={<PopupContent
            bodyText={MessageText}
            goalNames={goalNames}
            newI18n={newI18n}
            updateFilterAndRoute={updateFilterAndRoute}
          />}
          close={() => { setHoverCardStatus(false); }}
          popoverId={type}
        />}
      </div>
    );
  }, [MessageText, errorClassName, formattedNumber, goalNames, hoverCardStatus, newI18n, statusText, titleText, type, updateFilterAndRoute]);

  return renderLine();
}

PopupContent.defaultProps = {
  bodyText: '',
  goalNames: [],
  updateFilterAndRoute: _.noop,
};

PopupContent.propTypes = {
  bodyText: PropTypes.string,
  goalNames: PropTypes.arrayOf(PropTypes.string),
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  updateFilterAndRoute: PropTypes.func,
};


PopupContentNoRevenue.propTypes = {
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
export default Line;
